define([
	"dojo/_base/declare",
	"csi/action/FormData",
	"csi/table/NewFrom",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"csi/xml/Query",
	"SiteAdmin/RevisionHeadingsController"
], function(declare,FormData,NewFrom,ActionControllerMixin,xml,Query) {

	return declare([NewFrom,ActionControllerMixin], {

		getWizardViewQuery: function(/*csi.wizard.Widget*/wizard, /*csi.view.Widget*/view, /*Number*/index) {
			// summary: add a filter to the 2nd view in wizard if TestRunSection is selected in the toolbar
			var	q;
			var viewNode = this.widget.getViewNode();
			if (index == 1 && viewNode && viewNode.$Type == "TestRunSection" && viewNode.TestSpecSubtype) {
				q = new Query()
					.RefAttr("Subtype", xml.OP_EQUALS, viewNode.TestSpecSubtype, "Child:Actual/Child:__Parent__")
			}

			return q;
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard,
							 /*csi.wizard.Content*/currentPage,
							 /*csi.wizard.Content*/nextPage,
							 /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			var	fd = this.m_formData;
			var	bRefresh = false;

			if (wizard.getIndexOfPage(nextPage) == 0) {
				// moving to select-test-run table
				fd = new FormData(this);
				fd.m_bOmitSelections = true;
				fd.m_bRequireOne = true;
				fd.m_bSelectOne = true;
				fd.setNode(wizard.getViewNode());
				this.applyActionFilters(nextPage.getView(wizard));
			} else if (wizard.getIndexOfPage(nextPage) == 1) {
				// moving to select-tests table
				var	testRunNode = wizard.getFormDataFromPage(currentPage).getSelectedNode();

				// the next page may already have form data if user used back button; if so,
				// then just use form data already there; otherwise, use wizard's form data for
				// last page since that is what will be fed into controller for processing
				fd = wizard.getFormDataFromPage(nextPage) || wizard.defView.m_formData;

				// if form data node has changed, then reset selections and refresh view
				if (fd.getNode() != testRunNode) {
					fd.resetSelections();
					fd.setNode(testRunNode);
					bRefresh = true;
				}
			}

			// set form data for next page in wizard and refresh view if necessary
			return (fd && !bFinish) ? wizard.setFormDataToPage(nextPage, fd, bRefresh) : null;
		}
	});
});